export var legal = ""
